import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const Progress = (props: any) => {
  const [eventName, setEventName] = useState();
    const [eventNameFontSize, setEventNameFontSize] = useState<number>(30);
  const [daysLeft, setDaysLeft] = useState();
  const [progressPercentage, setProgressPercentage] = useState<any>();
  const [isArrived, setIsArrived] = useState("0");

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 50,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
  }));

  useEffect(() => {
    console.log('props.eventNameFontSize', props.eventNameFontSize);
    
    setEventNameFontSize(props.eventNameFontSize);
    if (props.settingEnd) {
      setEventName(props.eventName);
      const endLeft = props.endDate.diff(dayjs().startOf('day'), 'days');
      if (!props.startDate.isAfter(dayjs().startOf('day'), 'day')) {
        if (props.endDate.isBefore(dayjs().startOf('day'), 'day')) {
          setIsArrived("2");
          setDaysLeft(props.endDate);
          setProgressPercentage(100);
        } else {
          setIsArrived("0");
          setDaysLeft(endLeft < 0? 0 : endLeft);
          setProgressPercentage(() => {        
            const percentage = endLeft > 0? ((dayjs().startOf('day').diff(props.startDate.startOf('day'), 'days'))/props.endDate.diff(props.startDate.startOf('day'), 'days')) * 100 : 100;
            return endLeft === 0? "100" : percentage > 0? Math.round(percentage) : 0;
          });
        }
      } else {
        setIsArrived("1");
        setDaysLeft(props.startDate);
        setProgressPercentage(0);
      }
      props.setSettingEnd(false);
    }    
  }, [props.eventName, props.eventNameFontSize, props.startDate, props.endDate, props.settingEnd]);
  
  useEffect(() => {
    console.log('eventNameFontSize', eventNameFontSize);
    
  }, [eventNameFontSize]);

  return (
    <Box className="event-progress componentCore ">
      <Box className="core-color">
        <h6 style={{ fontSize: props.isIPad? (Number(eventNameFontSize) * props.scale) : eventNameFontSize }}>
          {eventName}
        </h6>
      </Box>
      <Box className="core-color">
        {isArrived === "0"? (
          <Typography>
            {daysLeft} days left
          </Typography>
        ) : (
          <React.Fragment>
            {isArrived === "1"? (
              <Typography>
                Starts on {dayjs(daysLeft).format("MMMM D, YYYY")}
              </Typography>
            ) : (
              <Typography>
                Finished on {dayjs(daysLeft).format("MMMM D, YYYY")}
              </Typography>
            )}
          </React.Fragment>
        )}
      </Box>
      <div className="core-color  overflow-hidden">
        <div className="progress">
          <div className="progress-text">{progressPercentage}%</div>
          <div className="progress-bar" style={{ width: `${progressPercentage}%` }}>
            <div className="progress-text">{progressPercentage}%</div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default Progress;